import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { List, Input, Layout, Row, Col, Icon, Button, Select } from 'antd'
import RightParametersPopup from '@components/Popup/RightParametersPopup'
import RightParamSetPopup from '@components/Popup/RightParamSetPopup'
import PoliciesTablePopup from '@components/Popup/PoliciesTablePopup'
import { policies } from '@services/api'

@inject((store: any) => {
    const {
        authStore,
        parametersStore,
        rightsStore,
        rightsParametersStore,
        popupStore,
        paramGroupsStore,
        rightParamSetStore,
        policiesStore
    } = store
    return {
        authStore,
        parametersStore,
        rightsStore,
        rightsParametersStore,
        popupStore,
        paramGroupsStore,
        rightParamSetStore,
        policiesStore
    }
})
@observer
export default class RightsParameters extends Component<any> {
    handleToggleRightParameters = async item => {
        const { parametersStore, popupStore, policy } = this.props
        parametersStore.getParametersList({
            right_param_set_id: policy.right_param_set_id,
            policy_id: policy.id,
            right_id: item.id
        })
        popupStore.togglePopup('rightParameters', { ...item, policy_id: policy.id })
    }
    handleToggleRightParamSet = () => {
        const { policy, rightParamSetStore } = this.props
        this.props.popupStore.togglePopup('rightParamSets', {
            title: 'בחר טבלה לשיוך פוליסה',
            buttonText: 'שייך טבלה',
            right_param_set_id: policy.right_param_set_id,
            confirmation: 'אזהרה! שיוך פוליסה לטבלה אחרת תגרור מחיקת הגדרות פרמטרים כיסויים פרמטרים תחת פוליסה זו'
        })
        rightParamSetStore.getList()
    }
    handleAssignRightParamSet = async right_param_set_id => {
        const { updatePolicy, policy, rightParamSetStore, rightsStore } = this.props
        await policies.updateRightParamSet({ id: policy.id, right_param_set_id })
        await rightParamSetStore.getList()
        await rightsStore.getRightsList({ right_param_set_id, policy_id: policy.id })
        updatePolicy(policy.id)
        rightsStore.resetFilters()
    }
    render() {
        const { rightsStore, policy, popupStore } = this.props
        return (
            <Layout style={{ padding: '1rem', backgroundColor: 'white' }}>
                <Row justify="space-between">
                    <Col>
                        <h5>
                            {policy.right_param_set_id
                                ? `הפוליסה משוייכת לטבלת - ${policy.right_param_set_name}`
                                : 'הפוליסה לא משוייכת לטבלה'}
                            |
                            <a
                                onClick={() => this.handleToggleRightParamSet()}
                                style={{
                                    color: '#e77910',
                                    fontSize: '1rem',
                                    marginLeft: '0',
                                    marginRight: '0.7rem',
                                    textDecoration: 'underline',
                                    fontWeight: 'bold'
                                }}
                            >
                                {policy.right_param_set_id ? 'שייך לטבלה אחרת' : 'בחר טבלה לשיוך'}
                            </a>
                            {policy.right_param_set_id ? (
                                <a
                                    onClick={() => popupStore.togglePopup('policiesTable', { policy })}
                                    style={{
                                        color: '#e77910',
                                        fontSize: '1rem',
                                        marginLeft: '0',
                                        marginRight: '0.7rem',
                                        textDecoration: 'underline',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    {'שכפל פרמטרים מפוליסה אחרת'}
                                </a>
                            ) : (
                                ''
                            )}
                        </h5>
                    </Col>
                </Row>
                <Row gutter={12} style={{ margin: '1rem 0' }}>
                    <Col xs={12}>
                        <Input.Search
                            value={rightsStore.filters['name']}
                            onChange={e => rightsStore.addFilter('name', e.target.value)}
                            placeholder="סנן זכויות על פי שם"
                        />
                    </Col>
                    <Col xs={12}>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="סנן לפי רלוונטיות"
                            value={rightsStore.filters['relevant']}
                            onChange={e => rightsStore.addFilter('relevant', e)}
                        >
                            <Select.Option value={null} key="ALL">
                                הצג הכל
                            </Select.Option>
                            <Select.Option value="RELEVANT" key="RELEVANT">
                                הצג כיסויים רלוונטיים
                            </Select.Option>
                            <Select.Option value="NOTRELEVANT" key="NOTRELEVANT">
                                הצג כיסויים לא רלוונטיים
                            </Select.Option>
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <List
                            dataSource={rightsStore.filteredList}
                            pagination={{ pageSize: 10 }}
                            renderItem={item => {
                                const included = item['__meta__'].right_parameters_count > 0
                                return (
                                    <List.Item
                                        style={{
                                            justifyContent: 'space-between',
                                            padding: '1rem',
                                            background: `${included ? 'white' : '#f5f5f5'}`
                                        }}
                                    >
                                        <div>
                                            <span style={{ marginLeft: '1rem' }}>
                                                {included ? <Icon type="check" /> : <Icon type="close" />}
                                            </span>
                                            <Button onClick={() => this.handleToggleRightParameters(item)}>
                                                <Icon type="unordered-list" /> פרמטרים
                                            </Button>
                                            <span style={{ fontWeight: included ? 'bold' : 'normal' }}>
                                                {item['name']}
                                            </span>
                                        </div>
                                        <div>מזהה: {item['id']}</div>
                                    </List.Item>
                                )
                            }}
                        />
                    </Col>
                </Row>
                <RightParamSetPopup rightParamSetSubmit={item => this.handleAssignRightParamSet(item.id)} />
                <RightParametersPopup />
                <PoliciesTablePopup
                    right_param_set_id={policy.right_param_set_id}
                    onSuccses={async item => {
                        await rightsStore.getRightsList({
                            right_param_set_id: item.right_param_set_id,
                            policy_id: policy.id
                        })
                        await rightsStore.applyFilters()
                    }}
                />
            </Layout>
        )
    }
}
